"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetBillingService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const billingGateDialog_1 = require("./billingGate/billingGateDialog");
const planCheckout_1 = require("./market/planCheckout");
const versetFacilityMechanism_1 = require("./versetFacilityMechanism");
let VersetBillingService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetBillingService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({});
            this.gate = null;
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetBillingService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        showGate(option = {}) {
            const gate = this.getGate();
            gate.show(option);
        }
        showSubscriptionGate() {
            this.showPlans();
        }
        async showPaymentRequiredGate() {
            const [billing, reason] = await versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer()
                .rpcs.VersetUserBillingService.getMyBilling({});
            const hasActivePaidSubscription = !reason
                && billing?.subscription?.state.startsWith("active")
                && billing.subscription.plan
                && billing.subscription.plan !== "free";
            if (hasActivePaidSubscription) {
                this.showGate({
                    source: `${billing.subscription.plan} plan included usage is exhausted`,
                });
                return;
            }
            this.showPlans({ exhausted: true, refreshAt: billing?.inPlanCreditResetAt });
        }
        getGate() {
            if (!this.gate) {
                this.gate = new billingGateDialog_1.BillingGateDialog();
            }
            return this.gate;
        }
        showPlans(option = {}) {
            planCheckout_1.PlanCheckout.show(option);
        }
    };
    return VersetBillingService = _classThis;
})();
exports.VersetBillingService = VersetBillingService;
